<mat-form-field class="bms-theme full-width full-height overflow-hidden no-subscript flex-center" (click)="stopClickEvent($event)">
  @if (isObjectSelection()) {
    <vdw-object-selection
      class="full-width full-height"
      [formControl]="formControl"
      [objectName]="getObjectName()"
      [canShowBMSTheme]="true"
      [withDialogObjectSelection]="true"
      [canShowMultiSelectPlaceHolder]="multiple"
      (selectClicked)="selectObject()"
    ></vdw-object-selection>
  } @else if (hasUnit()) {
    <input
      #inputElement
      matInput
      vdwAutoFocus
      [autoSelect]="autoSelect"
      type="number"
      autocomplete="off"
      vdwL10nDecimal
      [decimals]="allowDecimals"
      [maximumFractionDigits]="maximumFractionDigits"
      [formControl]="formControl"
      [placeholder]="placeholder"
      [min]="min"
      [max]="max"
    />
  } @else if (date) {
    <input
      #inputElement
      matInput
      vdwAutoFocus
      [formControl]="formControl"
      [placeholder]="'ANGULAR_COMPONENT_LIBRARY.CUSTOM_CELL_EDITOR.SELECT_DATE' | bmsTranslate"
      [min]="min"
      [max]="max"
      (dateInput)="onDateChange()"
      matDatepicker
    />
  } @else {
    <input #inputElement matInput vdwAutoFocus [autoSelect]="autoSelect" type="text" [formControl]="formControl" [maxlength]="max" [placeholder]="placeholder" />
  }

  @if (!isObjectSelection() && canShowClearInputButton()) {
    <button class="clear-input-button" mat-icon-button type="button" tabindex="-1" (click)="reset($event)">
      <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
    </button>
  }

  @if (hasUnit()) {
    <span matSuffix>{{ unit }}</span>
  }

  @if (canShowErrorMessage) {
    <mat-icon
      matSuffix
      class="icon-18 cursor-pointer"
      svgIcon="solid-error-circle-rounded"
      [matTooltip]="getErrorMessage() | bmsTranslate"
      matTooltipPosition="above"
      matTooltipClass="unset-max-width error"
    ></mat-icon>
  } @else if (notation) {
    <mat-icon matSuffix svgIcon="solid-nest-clock-farsight-analog"></mat-icon>
  } @else if (date) {
    <mat-icon matSuffix svgIcon="solid-calendar-today"></mat-icon>
  }
</mat-form-field>

@if (notation) {
  <vdw-time-picker-menu [notation]="notation" [selectedTime]="formControl.value" (selectedTimeChange)="formControl.setValue($event)"></vdw-time-picker-menu>
}

@if (date) {
  <div class="calendar">
    <mat-calendar
      #calendar
      class="bms-theme"
      [headerComponent]="datepickerHeader"
      [minDate]="min"
      [maxDate]="max"
      (selectedChange)="onSelectedChanges($event)"
      [selected]="formControl.value"
      [startAt]="formControl.value"
    >
    </mat-calendar>
    <div class="calendar-buttons flex-row flex-space-between">
      <button mat-button (click)="formControl.setValue(null)">{{ 'ANGULAR_COMPONENT_LIBRARY.DATEPICKER.CLEAR' | bmsTranslate }}</button>
      <button mat-button [disabled]="!canSetToday()" (click)="setToday()">{{ 'ANGULAR_COMPONENT_LIBRARY.DATEPICKER.TODAY' | bmsTranslate }}</button>
    </div>
  </div>
}
